import { type RouteRecordRaw } from 'vue-router'

export const oauthRouter: RouteRecordRaw[] = [
  {
    component: async () => import('../views/OauthStripeView.vue'),
    meta: {
      title: 'oauth.stripe',
    },
    name: 'oauth.stripe',
    path: 'oauth/stripe',
    props: {
      provider: 'stripe',
    },
  },
  {
    component: async () => import('../views/OauthGoogleServiceView.vue'),
    meta: {
      title: 'oauth.google-service',
    },
    name: 'oauth.google-service',
    path: 'oauth/google-service',
  },
]
